// Auto-generated by scripts/split_calculators.py — keeps deterministic oilfield formulas in per-category modules.
import { round, num, positive, toRad } from "./_common";
// eslint-disable-next-line no-unused-vars
const _imports_ok = { round, num, positive, toRad };

// ===== Category: trip =====
// --- Trip ---
// =========================================================================
// TRIP
// =========================================================================

export function pipeDisplacement({ od, id, length }) {
  const O = positive(num(od, "Pipe OD"), "Pipe OD");
  const I = num(id, "Pipe ID");
  if (I < 0 || I >= O) throw new Error("Pipe ID must be 0 ≤ ID < OD");
  const L = positive(num(length, "Length"), "Length");
  const disp = ((O * O - I * I) / 1029.4) * L;
  return {
    result: round(disp, 3),
    unit: "bbl",
    formula: "Disp = ((OD² − ID²) / 1029.4) × L",
    steps: [
      `OD=${O}", ID=${I}", L=${L} ft`,
      `Disp = (${O}² − ${I}²) / 1029.4 × ${L}`,
      `Disp = ${round(disp, 3)} bbl`,
    ],
    inputs: { "Pipe OD (in)": O, "Pipe ID (in)": I, "Length (ft)": L },
  };
}

export function expectedTripTankFill({ displacementBblFt, lengthPulled }) {
  const D = positive(num(displacementBblFt, "Displacement"), "Displacement");
  const L = positive(num(lengthPulled, "Length Pulled"), "Length Pulled");
  const v = D * L;
  return {
    result: round(v, 3),
    unit: "bbl",
    formula: "Trip Tank Fill = Displacement (bbl/ft) × Length Pulled",
    steps: [
      `Disp = ${D} bbl/ft, L = ${L} ft`,
      `Expected fill = ${D} × ${L} = ${round(v, 3)} bbl`,
    ],
    inputs: { "Displacement (bbl/ft)": D, "Length Pulled (ft)": L },
  };
}

export function pulledVsFilled({ expectedFill, actualFill }) {
  const E = num(expectedFill, "Expected Fill");
  const A = num(actualFill, "Actual Fill");
  const diff = A - E;
  const status = diff > 0.1 ? "GAIN — possible influx" : diff < -0.1 ? "LOSS — possible loss circulation" : "Balanced";
  return {
    result: round(diff, 3),
    unit: "bbl",
    formula: "Δ = Actual Fill − Expected Fill",
    steps: [
      `Expected = ${E} bbl, Actual = ${A} bbl`,
      `Δ = ${A} − ${E} = ${round(diff, 3)} bbl`,
      `Status: ${status}`,
    ],
    inputs: { "Expected (bbl)": E, "Actual (bbl)": A },
    extras: { Status: status },
  };
}

export function slugVolume({ dpCapacity, dryPipeLength, slugWeight, mudWeight }) {
  const Cap = positive(num(dpCapacity, "DP Capacity"), "DP Capacity");
  const L = positive(num(dryPipeLength, "Dry Pipe Length"), "Dry Pipe Length");
  const Ws = positive(num(slugWeight, "Slug Weight"), "Slug Weight");
  const Wm = positive(num(mudWeight, "Mud Weight"), "Mud Weight");
  if (Ws <= Wm) throw new Error("Slug weight must be greater than mud weight");
  // Slug volume so that hydrostatic equals mud column of (L + slugLen).
  // Simplified: V_slug = DP_cap × L × Ws / (Ws − Wm)
  const v = Cap * L * (Ws / (Ws - Wm));
  return {
    result: round(v, 2),
    unit: "bbl",
    formula: "V_slug = Cap × L × Ws / (Ws − Wm)",
    steps: [
      `Cap=${Cap} bbl/ft, L=${L} ft, Ws=${Ws} ppg, Wm=${Wm} ppg`,
      `V = ${Cap} × ${L} × (${Ws}/(${Ws}−${Wm}))`,
      `V = ${round(v, 2)} bbl`,
    ],
    inputs: { "DP Capacity (bbl/ft)": Cap, "Dry Pipe Length (ft)": L, "Slug Wt (ppg)": Ws, "Mud Wt (ppg)": Wm },
  };
}

